import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'modal-share',
  templateUrl: './modal-share.component.html',
  styleUrls: ['./modal-share.component.scss']
})
export class ModalShareComponent implements OnInit {
  statusCopy: string;

  url: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalShareComponent>
  ) { }

  ngOnInit(): void {
    this.url = this.data.isInformant === 0
      ? this.data.link : `${this.data.link}?IS_MULTI_INFORMANT=1`
  }

  copy(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.statusCopy = 'Copy เรียบร้อยแล้ว ✔';
  }

  closeModal() {
    const response = {
      status: false,
      value: {}
    }

    this.dialogRef.close(response);
  }

}
